import React , { Component } from 'react';
import '../../css/stylesheets/partials/selectdocpopup.css'

class Popup extends Component{

  render(){
    return (
      <div className="popup-box">
        <div className="box">
          <span className="close-icon" onClick={this.props.handleClose}>x</span>
          {this.props.content}
        </div>
      </div>
    )
  }
}

export default Popup;
